import { gql } from "apollo-boost";

export const CREATE_REWARD= gql`
mutation CreateReward($data: RewardInput!) {
  createReward(data: $data) {
    id
    name
    description
    image
    maxDiscountAmount
    maxUser
    percent
    pointMax
    pointMin
    remainUser
    rewardType
    startDate
    endDate
    status
  }
}
`
export const CREATE_REWARD_V2= gql`
mutation CreateRewardV2($data: RewardInputV2!) {
  createRewardV2(data: $data) {
        id
    name
    description
    image
    maxDiscountAmount
    maxUser
    percent
    pointMax
    pointMin
    remainUser
    rewardType
    startDate
    endDate
    status
    userType
  }
}
`

export const UPDATE_REWARD = gql`
mutation UpdateReward($data: RewardInput!, $where: RewardWhereInputOne!) {
  updateReward(data: $data, where: $where) {
    name
    description
    maxDiscountAmount
    rewardType
    percent
    pointMax
    pointMin
    remainUser
    maxUser
    status
    startDate
    endDate
  }
}
`
export const UPDATE_REWARD_V2 = gql`
mutation UpdateRewardV2($data: RewardInputV2!, $where: RewardWhereInputOne!) {
  updateRewardV2(data: $data, where: $where) {
    name
    description
    maxDiscountAmount
    rewardType
    percent
    pointMax
    pointMin
    remainUser
    maxUser
    status
    startDate
    endDate
  }
}
`

export const DELETE_REWARD = gql`
mutation DeleteReward($where: RewardWhereInput!) {
  deleteReward(where: $where) {
    isDeleted
  }
}
`